import { color } from '@op/opds.tokens';

// Get percent
export const getPercent = (max: number, value: number): number => {
  return (value / max) * 100 || 0;
};

// Get feedback level based on score percent
export const getFeedbackLevel = (percentage: number): number => {
  const maxLevels = 5;
  const step = 100 / maxLevels;
  let level = 0;
  for (let i = 0; i < maxLevels; i += 1) {
    const threshold = (i + 1) * step;
    if (threshold >= percentage) {
      level = i;
      break;
    }
  }
  return level;
};

// Bullet colors
export const bulletColors = [
  color.indicator.default,
  color.indicator.passive,
  color.text.secondary,
  color.indicator.warning,
  color.indicator.positive,
  color.indicator.notification,
  color.indicator.negative,
  color.text.default,
  color.background.tertiary,
  color.text.highlight.small,
  color.text.positive.small,
];
